import { Output } from "valibot";

import { BotInfoSchema } from "components/SonicBot/schemas";
import { useGlobalsContext } from "shared/hooks";
import { Literals } from "shared/types";
import { ReactComponent as IconClose } from "assets/images/icons/close-inverted.svg";

type Props = {
  botInfo: Output<typeof BotInfoSchema>;
  collapsedBarMode: boolean;
  setIsEndChatModalOpen?: React.Dispatch<React.SetStateAction<boolean>>;
  setIsCloseWidgetAfterEndChat?: React.Dispatch<React.SetStateAction<boolean>>;
  copyTexts: Literals;
};

function ButtonClose(props: Props) {
  const {
    botInfo,
    collapsedBarMode,
    setIsEndChatModalOpen,
    setIsCloseWidgetAfterEndChat,
    copyTexts,
  } = props;

  const { setWidgetExpanded } = useGlobalsContext();

  return (
    <button
      className="group absolute -right-2 top-[-1px] border-none bg-transparent"
      onClick={() => {
        if (!botInfo.bot_info_config.show_post_chat_feedback) {
          return setWidgetExpanded(false);
        }
        collapsedBarMode
          ? setIsEndChatModalOpen && setIsEndChatModalOpen(true)
          : setWidgetExpanded(false);
        setIsCloseWidgetAfterEndChat && setIsCloseWidgetAfterEndChat(true);
      }}
    >
      <IconClose />
      <p className="absolute right-0 hidden max-w-min rounded-lg bg-black px-2 py-1 text-white opacity-80 group-hover:block">
        {copyTexts.minimizeButtonText}
      </p>
    </button>
  );
}

export default ButtonClose;
